import { Capability, User } from 'src/models/user.model';
import { SYSTEM_ROLE } from '../config/constants';

export const groupCapabilities = (capabilities: Capability[]) => {
  const groupedCapabilities: Record<string, Capability[]> = {
    Account: [],
    Anagrafiche: [],
    Rapportini: [],
    Commesse: [],
    'Profili e autorizzazioni': [],
  };

  capabilities.forEach(capability => {
    switch (capability.name) {
      case EDIT_ANAGRAPHIC_PERMISSION:
      case VIEW_ANAGRAPHIC_PERMISSION:
        groupedCapabilities.Anagrafiche.push({
          ...capability,
          name: capability.name === EDIT_ANAGRAPHIC_PERMISSION ? 'Modifica anagrafiche' : 'Visualizza elenco anagrafiche',
        });
        break;

      case EDIT_TIMESHEET_PERMISSION:
      case VIEW_TIMESHEETS_PERMISSION:
      case DOWNLOAD_TIMESHEET_PERMISSION:
        groupedCapabilities.Rapportini.push({
          ...capability,
          name:
            capability.name === EDIT_TIMESHEET_PERMISSION
              ? 'Modifica rapportini'
              : capability.name === VIEW_TIMESHEETS_PERMISSION
              ? 'Visualizza elenco rapportini'
              : 'Download rapportino',
        });
        break;

      case EDIT_COMMISSION_PERMISSION:
      case VIEW_COMMISSION_PERMISSION:
        groupedCapabilities.Commesse.push({
          ...capability,
          name: capability.name === EDIT_COMMISSION_PERMISSION ? 'Modifica commesse' : 'Visualizza gestione commesse',
        });
        break;

      case EDIT_ACCOUNT_PERMISSION:
        groupedCapabilities.Account.push({
          ...capability,
          name: 'Modifica propria anagrafica',
        });
        break;

      case VIEW_CAPABILITIES_PERMISSION:
      case EDIT_CAPABILITIES_PERMISSION:
        groupedCapabilities['Profili e autorizzazioni'].push({
          ...capability,
          name:
            capability.name === EDIT_CAPABILITIES_PERMISSION ? 'Modifica profili e autorizzazioni' : 'Visualizza profili e autorizzazioni',
        });
        break;

      default:
        break;
    }
  });

  return groupedCapabilities;
};

export const EDIT_COMMISSION_PERMISSION = 'commissions, w';
export const VIEW_COMMISSION_PERMISSION = 'commissions, r';

export const EDIT_TIMESHEET_PERMISSION = 'timesheet, w';
export const VIEW_TIMESHEETS_PERMISSION = 'timesheet, r';
export const DOWNLOAD_TIMESHEET_PERMISSION = 'timesheet, d';

export const VIEW_ANAGRAPHIC_PERMISSION = 'anagraphic, r';
export const EDIT_ANAGRAPHIC_PERMISSION = 'anagraphic, w';

export const EDIT_ACCOUNT_PERMISSION = 'devAccount, w';

export const VIEW_CAPABILITIES_PERMISSION = 'capabilities, r';
export const EDIT_CAPABILITIES_PERMISSION = 'capabilities, w';

export const isAuthorizedToHandleCapability = (user: User, capability: string): boolean => {
  return user?.authority?.name === SYSTEM_ROLE || user.capabilities?.some(item => item === capability) || false;
};
